import { createAction } from '@reduxjs/toolkit';
import { Recommendations } from '~domain/personalize/Recommendations';

const ACTION_BASE_TYPE = 'PERSONALIZE';

export const receiveRecommendations = createAction<Recommendations>(
  `${ACTION_BASE_TYPE}/RECEIVE_RECOMMENDATIONS`
);
